import { dateFriendly } from '../helpers/date';
/**
 * transform channel
 * @param {Object} channel
 * @returns {Object} channel
 */
export const transformChannel = (data = {}) => {
	return {
		id: data.id,
		name: data.name,
		slug: data.slug,
		type: data.type,
		url: data.url,
		description: data.description,
		createdAt: data.created_at ? dateFriendly(data.created_at, 'DD MMM YYYY') : '-',
		updatedAt: data.updated_at ? dateFriendly(data.updated_at, 'DD MMM YYYY') : '-',
	};
};

/**
 * transform channels
 * @param {Array} channels
 * @returns {Array} channels
 */
export const transformChannels = (data = []) => {
	return data.map((item) => transformChannel(item));
};
